import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { COOKIE_KEYS } from "@/shared/constants/cookies.const";

/**
 * Reads the token from the cookie on every render so `isAuthenticated` stays in sync after
 * `saveToken()` (e.g. login). Previously token lived only in state updated once on mount,
 * which sent users to /login while the URL was /my-discovery and broke the protected layout.
 */
export function useAuth() {
  const [hasMounted, setHasMounted] = useState(false);
  useEffect(() => {
    setHasMounted(true);
  }, []);

  const token = Cookies.get(COOKIE_KEYS.token) ?? null;

  return {
    token,
    isAuthenticated: Boolean(token),
    /** One tick after mount avoids treating the very first paint as “logged out” before hydration. */
    isLoading: !hasMounted,
  };
}
